import { Box } from '@mui/material';

import { GDMContainerComponent } from './GDMContainer.type';

/* TODO: Implement component using GDM default design */
const GDMContainer: GDMContainerComponent = ({ ...props }) => <Box {...props} />;

export default GDMContainer;
